import { Button, Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DataTable } from "../../components/global/Table/DataTable"
import { ActiveIcon } from "../../assets/svgs/ActiveIcon";
import { Link } from "../../components/global/Link";
import { EditIcon } from "../../assets/svgs/EditIcon";
import { DeactiveIcon } from "../../assets/svgs/DeactiveIcon";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AddBar } from "./AddBar";
import { EditBar } from "./EditBar";
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { PrimaryIcon } from "../../assets/svgs/PrimaryIcon";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";
import { BarData, CountryData } from "../../types";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'name',
    disablePadding: true,
    label: 'Name',
    align: 'left',
    sortable: true,
    searchable: true,
  },
  {
    id: 'active',
    disablePadding: false,
    label: 'Active',
    width: '50px',
  },
  {
    id: 'edit',
    disablePadding: false,
    label: 'Edit',
    width: '50px',
  },
];

interface BarTableData {
  id: any;
  name: any;
  active: JSX.Element;
  edit: JSX.Element;
}

export const Bars = () => {
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [rows, setRows] = useState<BarTableData[]>([]);
  const [countries, setCountries] = useState<CountryData[]>([]);

  const onAddBar = () => {
    navigate('/bars/create');
  }

  const onBulkDelete = async (ids: number[]) => {
    await fetchData('/bars/delete',  { id: ids }, 'POST');
    refetchBars();
  }

  const refetchBars = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/bars/all');
    setRows(getRows(data ?? []));
    isLoading.current = false;
    setSIsLoading(false);
  }

  const refetchCountries = async () => {
    const {errors, data} = await fetchData('/countries/all');
    setCountries(data ?? []);
  }

  const getRows = (bars: BarData[]) => {
    const result: BarTableData[] = [];
    for (let i=0; i<bars.length; i++) {
      result.push({
        id: `${bars[i].id}`,
        name: 
          <>
            <Typography style={{ margin: 0, color: bars[i].status ? 'inherit' : '#DCDCE0' }}>
              <span style={{fontSize: 18}}>{bars[i].name}</span>
              <br/>
              <span style={{fontSize: 15, fontStyle: 'italic'}}>{bars[i].address}</span>
            </Typography>
          </>,
        active: bars[i].status ? <ActiveIcon /> : <DeactiveIcon />,
        edit: <Link to={`/bars/${bars[i].id}`}><EditIcon /></Link>
      });
    }
    return result;
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchBars();
      refetchCountries();
    }
  }, [isAuthenticated]);

  return (
    <Frame title="Bars" toolbarButtons={(
      <>
        <Button variant="contained" onClick={onAddBar} startIcon={<PrimaryIcon width="22" height="15" color="#FFFFFF" />}>
          Add Bar
        </Button>
      </>
    )}>
      <Stack>
        <Routes>
          <Route
            path="/create/"
            element={<AddBar countries={countries} refetchBars={refetchBars} />}
          ></Route>
          <Route
            path="/:bar_id/"
            element={<EditBar countries={countries} refetchBars={refetchBars} />}
          ></Route>
        </Routes>
        <DataTable 
          title="Bars" 
          hideDeleteButton={true} 
          hideIdCheckbox={true} 
          headCells={headCells} 
          rows={rows} 
          onBulkDelete={onBulkDelete} 
          isLoading={sIsLoading}
        />
      </Stack>
    </Frame>
  )
}
